import { R as w, a as S } from "../select-9106b782.js";
import { I as T } from "../icon-51ff7679.js";
import V from "../assets/mixins/event.js";
import { resolveComponent as d, openBlock as r, createElementBlock as h, withDirectives as I, createElementVNode as s, normalizeClass as u, toDisplayString as c, createVNode as p, vShow as B, withCtx as A, Fragment as y, renderList as C, createBlock as D } from "vue";
import { _ as M } from "../_plugin-vue_export-helper-dad06003.js";
import "../assets/mixins/emitter.js";
import "../utils/gogocodeTransfer.js";
import "../assets/mixins/focus.js";
import "element-plus";
import "../scrollbar2-f7c66394.js";
import "../assets/utils/scrollbar-width.js";
import "../util-b2b0dc25.js";
import "../assets/utils/dom.js";
import "../scrollbar2/util.js";
import "../assets/utils/vue-popper.js";
import "../assets/utils/popup/popup-manager.js";
import "../assets/utils/popper.js";
import "../virtual-list/index.js";
import "../virtual-list-42654601.js";
import "../_commonjsHelpers-ce4d82cc.js";
import "../isSymbol-62c14278.js";
import "../toNumber-ea93c45b.js";
import "../assets/utils/clickoutside.js";
import "../assets/utils/scroll-into-view.js";
import "../select/src/navigation-mixin.js";
import "../assets/utils/shared.js";
const U = "data:image/png;base64,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", v = {
  name: "rCoinSelector",
  componentName: "rCoinSelector",
  model: {
    prop: "value",
    event: "item-change"
  },
  mixins: [V],
  components: {
    RSelect: w,
    ROption: S,
    RIcon: T
  },
  props: {
    /**
     * 是否展示全部选项
     */
    showAll: {
      type: Boolean,
      default: !0
    },
    /**
     * value是否展示为label模板样式
     */
    labelInValue: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    /**
     * 币种id
     */
    value: {
      type: [Number, String],
      default: null
    },
    /**
     * 币种列表接口的返回数组
     */
    responseData: {
      type: Array,
      default: () => []
    },
    /**
     * 主动传入组件所需格式的币种列表
     */
    coinList: {
      type: Array,
      default: () => []
    },
    /**
     * 是否加载中
     */
    loading: {
      type: Boolean,
      default: !1
    },
    /**
     * 选择框尺寸
     */
    size: {
      type: String,
      default: "default"
    },
    /**
     * 选择框宽度
     */
    width: {
      type: String,
      default: "180px"
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      list: [],
      renderData: {
        list: [],
        pageSize: 20,
        current: 0,
        finished: !1
      },
      queryText: "",
      optionsAll: this.showAll ? [
        {
          coinId: "",
          coinName: "",
          coinShortName: this.$t("bmui-symbol-cascader.all"),
          iconUrl: U
        }
      ] : [],
      inputValue: this.value,
      // 初始化
      showValTemplate: this.labelInValue
    };
  },
  computed: {
    optionList() {
      return this.queryText ? this.list.filter((e) => e.coinShortName.toUpperCase().includes(this.queryText.toUpperCase())) : this.renderData.list;
    },
    itemInValue() {
      if (!this.inputValue) {
        if (this.inputValue !== "")
          return;
        if (this.inputValue === "" && !this.showAll)
          return;
      }
      const e = this.list.find((t) => t.coinId === this.inputValue);
      return e || {
        coinId: "",
        iconUrl: "",
        coinShortName: "",
        coinName: ""
      };
    },
    iconStyle() {
      const e = [
        "el-select__caret",
        "el-input__icon",
        this.disabled ? "is-disabled" : "",
        "r-select-icon-arrow"
      ];
      return this.labelInValue && !this.showValTemplate ? e.push("el-icon is-reverse") : e.push("el-icon"), e;
    }
  },
  watch: {
    responseData: {
      handler(e) {
        e && e.length && this.handleParamsChange(this.coinList);
      },
      immediate: !0
    },
    coinList: {
      handler(e) {
        e && e.length && this.handleParamsChange(e);
      },
      immediate: !0
    }
  },
  methods: {
    showMenu() {
      this.disabled || (this.showValTemplate = !1, this.$refs.select.toggleMenu(), this.inputValue = void 0);
    },
    handleParamsChange(e) {
      if (e && e.length) {
        const t = JSON.parse(JSON.stringify(e));
        this.list = [...this.optionsAll, ...t], this.renderData.current = 0, this.renderData.list = [], this.loadMore();
        return;
      }
      this.setList();
    },
    setList() {
      const e = [];
      for (const t of this.responseData) {
        const { coinType: n, coinName: l, coinShortName: o, iconUrl: i } = t;
        e.push({ coinId: n, coinName: l, coinShortName: o, iconUrl: i });
      }
      this.list = [...this.optionsAll, ...e], this.renderData.current = 0, this.renderData.list = [], this.loadMore();
    },
    handleChange(e) {
      this.$emit("item-change", e);
    },
    onReachBottom() {
      this.loadMore();
    },
    loadMore() {
      var o;
      const { current: e, pageSize: t, list: n } = this.renderData, l = this.list.slice(
        e * t,
        ++this.renderData.current * t
      );
      if (l.length === 3 && ((o = l[0]) == null ? void 0 : o.coinId) === "" && (this.renderData.list = [...l]), l.length < t && this.renderData.current > 1) {
        this.eventEmit("COMP_SELECT_OPTION_unBindObserve"), this.eventEmit("COMP_SELECT_OPTION_loadFinished");
        return;
      }
      this.renderData.list = [...n, ...l];
    },
    query(e) {
      this.queryText = e;
    },
    onVisibleChange(e) {
      this.queryText = "";
    },
    setShowValTemplate(e) {
      this.inputValue = this.value, this.showValTemplate = !e;
    }
  },
  created() {
  }
}, N = { class: "r-coin-selector" }, _ = {
  key: 0,
  class: "option-item"
}, L = ["src"], R = { class: "coin-short-name" }, z = { class: "coin-name" }, O = {
  key: 1,
  class: "option-item"
}, x = { class: "placeholder" }, E = { class: "option-item-wrapper" }, F = { class: "option-item" }, q = ["src"], J = { class: "coin-short-name" }, Y = { class: "coin-name" };
function P(e, t, n, l, o, i) {
  const f = d("RIcon"), g = d("ROption"), b = d("RSelect");
  return r(), h("div", N, [
    I(s(
      "div",
      {
        onClick: t[0] || (t[0] = (...a) => i.showMenu && i.showMenu(...a)),
        class: u(["is-label-in-value", n.size, n.disabled ? "is-disabled" : ""])
      },
      [
        i.itemInValue ? (r(), h("div", _, [
          s("img", {
            class: "coin-icon",
            src: i.itemInValue.iconUrl
          }, null, 8, L),
          s(
            "span",
            R,
            c(i.itemInValue.coinShortName),
            1
            /* TEXT */
          ),
          s(
            "span",
            z,
            c(i.itemInValue.coinName),
            1
            /* TEXT */
          )
        ])) : (r(), h("div", O, [
          s(
            "span",
            x,
            c(n.placeholder || e.$t("bmui-select.placeholder")),
            1
            /* TEXT */
          )
        ])),
        s(
          "div",
          {
            class: u(["arrow-icon", o.showValTemplate ? "is-show" : "is-hidden"])
          },
          [
            p(f, {
              class: u([]),
              name: "icon-caret_down"
            })
          ],
          2
          /* CLASS */
        )
      ],
      2
      /* CLASS */
    ), [
      [B, o.showValTemplate]
    ]),
    p(b, {
      ref: "select",
      value: n.value,
      lazyLoad: "",
      filterable: "",
      filterMethod: i.query,
      width: n.width,
      disabled: n.disabled,
      placeholder: n.placeholder,
      onChange: i.handleChange,
      onReachBottom: i.onReachBottom,
      onVisibleChange: i.onVisibleChange,
      onMenuChange: t[1] || (t[1] = (a) => n.labelInValue && i.setShowValTemplate(a)),
      size: n.size
    }, {
      default: A(() => [
        (r(!0), h(
          y,
          null,
          C(i.optionList, (a) => (r(), D(g, {
            key: a.coinId,
            label: a.coinShortName,
            value: a.coinId
          }, {
            default: A(() => [
              s("div", E, [
                s("div", F, [
                  s("img", {
                    class: "coin-icon",
                    src: a.iconUrl
                  }, null, 8, q),
                  s(
                    "span",
                    J,
                    c(a.coinShortName),
                    1
                    /* TEXT */
                  ),
                  s(
                    "span",
                    Y,
                    c(a.coinName),
                    1
                    /* TEXT */
                  )
                ])
              ])
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["label", "value"]))),
          128
          /* KEYED_FRAGMENT */
        ))
      ]),
      _: 1
      /* STABLE */
    }, 8, ["value", "filterMethod", "width", "disabled", "placeholder", "onChange", "onReachBottom", "onVisibleChange", "size"])
  ]);
}
const m = /* @__PURE__ */ M(v, [["render", P], ["__file", "/Users/dave/Documents/dev/bmui3/src/packages/coin-selector/coin-selector.vue"]]);
m.install = function(e) {
  e.component(m.name, m);
};
export {
  m as default
};
